import "../../styles/Comun/Estados.css";

// Estado de carga (comprobar la sesión, descargar una ruta lazy).
// role="status": el lector de pantalla lo anuncia sin mover el foco.
const Cargando = ({ texto = "Cargando…" }) => (
  <div className="estado-ruta" role="status" aria-live="polite">
    <div className="estado-ruta__rueda" aria-hidden="true" />
    <p>{texto}</p>
  </div>
);

export default Cargando;
